<template>
	<div>

		<h2 class="mb-2">{{ $t("unmapped-learning-outcomes") }}</h2>
        <div class="row">
            <div class="col-12 col-md-4">
                <SelectInput
                    v-model="root_id"
                    @input="value => refresh({ root_id: value })"
                    :label="$t('programme')"
                    :options="programmes"
                    optionLabel="title"
                    optionValue="id"
                    :nullLabel="$t('curricula')"
                    :srOnly="true"
                />
            </div>
            <div class="col-12 col-md-4">
                <SearchBar 
                    v-model="filters.search" 
                    :placeholder="$t('search')"
                    @input="value => refresh({ search: value })" 
                />
            </div>
        </div>
        
		<div v-if="loaded && learningoutcomes.length > 0" class="list-group">
			<div class="list-group-item d-none d-sm-inline">
				<div class="row">
					<div class="col-12 col-sm-4 font-bold">{{ $t("name") }}</div>
					<!--div class="col-12 col-sm-6 font-bold">{{ $t("notes") }}</div-->
				</div>
			</div>
			<div class="list-group-item" v-for="(outcome,key) in learningoutcomes" :key="key" @click="selectOutcome(outcome.id)" @contextmenu.prevent="deletingOutcome = outcome.id">
				<p class="mb-0"> {{ outcome.title }} </p>
				<p class="mb-0"> {{ outcome.note ? outcome.note : $t('no-notes') }} </p>
			</div>
		</div>

		<div class="card text-center" v-else-if="loaded">
			<div class="card-body">
				<p class="mb-0">{{ $t('none') }}</p>
			</div>
		</div>

		<table v-else class="table">
			<tr v-for="item in Array(5)" v-bind:key="item">
				<td>
					<div class="skeleton midnight h16 w-half"></div>
				</td>
				<!--td>
					<div class="skeleton midnight h16 w-half"></div>
				</td-->
			</tr>
		</table>

	</div>
</template>

<script>
import SearchBar from "src/components/Table/SearchBar.vue"

export default {
	components: {
        SearchBar
	},
	data: function () {
		return {
			loaded: true,
            learningoutcomes: [],
            filters:{
                unmapped:true,
                root_id:[],
                search:null
            },
            root_id:null,
            programmes:[]
		};
	},
	mounted() {
		this.getLearningOutcomes();
        this.getProgrammes();
	},
	methods: {
        getLearningOutcomes() {
            this.$cfetch(`${this.$settings.APIBaseURL}/learningoutcome/list`,{
                method: "post",
                data: this.filters
            })
            .then((res) => {
				if (res.status === "SUCCESS") {
                    this.learningoutcomes = res.results;
                    this.loaded = true;
				} else {
					console.log(res.status)
				}
			}).catch(error => {
				this.$log.error.call(this, error);
			});
        },
		selectOutcome(id) {
            if(!this.$UserSession.hasPriv.call(this, 'CURRICULUM_MANAGE')) return;
			if(id){
				this.$router.push(`/curriculum-mapping/learning-outcomes/edit/${id}`);
			}
		},
        getProgrammes(){
            this.$cfetch(`${this.$settings.APIBaseURL}/curriculummap/listroots`,{
                method: "post"
            })
            .then((res) => {
				if (res.status === "SUCCESS") {
                    this.programmes = res.results;
				} else {
					console.log(res.status)
				}
			}).catch(error => {
				this.$log.error.call(this, error);
			});
        },
        refresh(filters) {
            this.filters = { ...this.filters, ...filters}
            this.getLearningOutcomes();
        },
	}
};
</script>


